// extracted by mini-css-extract-plugin
export default {"transactionHistory":"TransactionHistory_transactionHistory__h95cH"};